/* global localStorage */

import axios from 'axios'
import qs from 'qs'

import { getMessageFromRequestErrorObject } from '../utils/api'

export const API_URL = process.env.REACT_APP_STAGING
  ? process.env.REACT_APP_API_URL_STAGING
  : process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000/admin'
    : process.env.REACT_APP_API_URL

function axiosClient () {
  const axiosClient = axios.create({
    baseURL: API_URL,
    timeout: 15000,
    headers: {
      Authorization: localStorage.getItem('auth')
    },
    paramsSerializer: function (params) {
      return qs.stringify(params, {arrayFormat: 'brackets'})
    }
  })

  if (process.env.NODE_ENV === 'development') {
    axiosClient.interceptors.request.use(request => {
      console.log('Starting Request', request)
      return request
    }, err => {
      console.log('request error', err)
      return Promise.reject(err)
    })

    axiosClient.interceptors.response.use(response => {
      console.log('Response:', response)
      return response
    }, err => {
      console.log('response error', err)
      err.message = getMessageFromRequestErrorObject(err)
      return Promise.reject(err)
    })
  }
  return axiosClient
}

export default axiosClient
